<section>
  <div class="row" style="display: flex;">
    <div class="col-sm-4">
      <span class="backButton" (click)="goBack()"><img style="height: 20px" src="assets/back_arrow.png"></span>
    </div>
    <div class="col-sm-8 header">
      <h1>BOOKING ID // {{bookingId}}</h1>
    </div>
  </div>
</section>
<section>
  <div class="split left">
    <div style="display: flex;">
      <button class="activeButton" id="system" (click)="openSystemInvoice()">System Invoice</button>
      <button class="button" id="vendor" *ngIf="vendorInvoiceConfig.config.visibility.visible && showInvoiceFiles" (click)="getInvoiceUploaded()">Vendor Invoice</button>
    </div>
    
      <ng-container>
        <div *ngIf="showPreviewUrl" class="height-100-p width-100-p">
            <iframe [cachedSrc]="previewUrl" class="height-100-p width-100-p"></iframe>
        </div>
        <div *ngIf="!showPreviewUrl" class="noData">
          <p>No Preview Available</p>
      </div>
      </ng-container>
     
  </div>
  
  <div class="split right">
    <div style="display: flex;">
      <app-single-select *ngIf= "tollConfig.config.visibility.visible"
       [width]="'145px'" [disabled]="tollDisable" [values]="tollUploadedFiles" [placeHolder]="tollConfig.config.displayName" [displayName]="'fileName'" [showSearchBox]="false" (onSelect)="selectFile($event)" ></app-single-select> 
      <app-single-select  *ngIf= "permitConfig.config.visibility.visible"
      [width]="'145px'" [disabled]="permitDisable" [values]="permitUploadedFiles" [placeHolder]="permitConfig.config.displayName" [displayName]="'fileName'" [showSearchBox]="false" (onSelect)="selectFile($event)" ></app-single-select> 
      <app-single-select  *ngIf= "parkingConfig.config.visibility.visible"
      [width]="'145px'" [disabled]="parkingDisable" [values]="parkingUploadedFiles" [placeHolder]="parkingConfig.config.displayName" [displayName]="'fileName'" [showSearchBox]="false" (onSelect)="selectFile($event)" ></app-single-select> 
      <app-single-select  *ngIf= "othersConfig.config.visibility.visible"
      [width]="'145px'" [disabled]="othersDisable" [values]="othersUploadedFiles" [placeHolder]="othersConfig.config.displayName" [displayName]="'fileName'" [showSearchBox]="false" (onSelect)="selectFile($event)" ></app-single-select> 
    </div>
    <ng-container>
      <div *ngIf="showFileUrl">
          <img [src]="fileUrl" class="fileSection"/>
      </div>
      <div *ngIf="noFile" class="noData">
        <p>No File Available</p>
    </div>
    <div *ngIf="showPdf" class="height-100-p width-100-p">
      <iframe [cachedSrc]="fileUrl" class="height-100-p width-100-p"></iframe>
    </div>
    </ng-container>
  </div>
  <!-- <app-toast *ngIf="showApprovedToast" message="Action Saved Successfully." (dismissCallback)="dismissToast()"></app-toast> -->
</section>
<app-loader *ngIf="isLoading"></app-loader>
<section class="footer" *ngIf="pendingInvoice">
  <button 
    *ngIf="authService.user.role !== 'VENDOR_MANAGER'"
    class="action reject"
    (click)="isRider ? showRejectedPopup = true : rejectInvoice()"
  > <img src="assets/reject_invoice.svg"> Reject</button>
  <button 
    *ngIf="authService.user.role !== 'VENDOR_MANAGER'"
    class="action approve"
    (click)="showApprovePopup = true"
  > <img src="assets/accept_invoice.svg"> Approve</button>
</section>
<section class="footer" *ngIf="!pendingInvoice">
  <span [ngStyle]="{'color':getColor(invoiceStatus), 'font-weight': 'bold', 'font-size': '19px', 'margin': '16px'}"> {{invoiceStatus}} </span>
</section>
  

 <app-popover *ngIf="showRejectedPopup" size="small" titleText="Rejected Reason" (closeCallback)="dismissPopup()">

    <div popover-content>
      <div class="mb-10">Please provide the reason </div>  
      <textarea class="textbox" name="reason" #textarea [(ngModel)]="reasonText" 
      #reasonControl="ngModel" rows="3">
      </textarea>
      <div *ngIf="rejectReasonConfig === 'false'" style="font-style: italic;">(Optional)</div>
      <div class = "error" *ngIf="showReasonError">
        Reason is mandatory.
      </div>
    </div>
    <div popover-actions class="mt-20 flex flex-end">
      <app-button class="mr-10" type="plainText" text="Cancel" (clickCallback)="dismissPopup()">
      </app-button>
      <app-button type="primaryFilled" text="Submit" (clickCallback)="confirmRejection(textarea.value)"></app-button>
    </div>

</app-popover>

<app-popover *ngIf="showApprovePopup" size="small" (closeCallback)="closeModal()">

  <!-- For approval of invoice -->
  <div popover-header>
    Approve Invoice
  </div>
 
  <div popover-content>
    <div class="mb-10">Please provide your comments <span class="optional"
        *ngIf="rejectReasonConfig === 'false' && !approveReasonForAmountMismatch">(optional)</span></div>
    <textarea class="textbox" name="reason" [(ngModel)]="reasonText" 
    [maxlength]="maxLimit"
      [required]="rejectReasonConfig === 'true' || approveReasonForAmountMismatch"
      #reasonControl="ngModel" rows="3">
    </textarea>
    <div *ngIf="reasonControl.invalid">
      <div class="error-msg" *ngIf="isSubmitReasonClicked && reasonControl.errors.required">This Field is mandatory
      </div>
      <div class="error-msg" *ngIf="reasonControl.errors.maxlength">Limit Exceeded (Max limit - 200 characters)</div>
    </div>
    <div *ngIf="approveReasonForAmountMismatch">
      <span>
        *Please provide comments for approving this invoice. Vendor invoice amount and system invoice amount are different for this booking
      </span>
    </div>
  </div>
  <div popover-actions class="mt-20 flex flex-end">
    <app-button class="mr-10" type="plainText" text="Cancel" (clickCallback)="closeModal()">
    </app-button>
    <app-button type="primaryFilled" text="Submit" (clickCallback)="submitForApproval(reasonControl)"></app-button>
  </div>
</app-popover>


<app-toast *ngIf="showSuccess && status == 'APPROVED'" message="Document successfully approved" (dismissCallback)="closeToast()"></app-toast>
<app-toast *ngIf="showSuccess && status == 'REJECTED'" message="Document successfully rejected" (dismissCallback)="closeToast()"></app-toast>

<app-toast *ngIf="showError && status == 'APPROVED'" message="Document approval failed" (dismissCallback)="closeToast()"></app-toast>
<app-toast *ngIf="showError && status == 'REJECTED'" message="Document rejection failed" (dismissCallback)="closeToast()"></app-toast>

